import { jsx, jsxs } from "react/jsx-runtime";
import { Button, __css, mergeClasses, Text, tokens } from "@fluentui/react-components";
import { brandTokens } from "../../theme/themes.js";
const useStyles = __css({"root":{"mc9l5x":"f22iagw","Beiy3e4":"f1vx9l62","Bt984gj":"f122n59","Brf1p80":"f4d9j23","fsow6f":"f17mccla","Belr9w4":"f1noh358","Dbcxam":0,"rjzwhg":0,"Bblux5w":"f1hfhel7","Bnt446c":0,"B1hrpyx":0,"Fjva8n":"fnsi1rm","sj55zd":"fkfq4zb"},"illustration":{"mc9l5x":"f22iagw","Bt984gj":"f122n59","Brf1p80":"f4d9j23","Bns2gvi":"f1ejnbxg","st59p4":"f1sif4mv","Be2twd7":"fqonovg","sj55zd":"f16muhyy","De3pzq":"f1ac3ntu","D2ttc9":"fyvd8f1","frolq6":"f1d6f24m","Bhowxqw":"f1pqui0w","Bg3xm0u":"fgs7pz1","Behc1zw":"fsxozpy","uk9mye":"f1p2dij1","mbw9mh":"f11m8539","rjzwhg":"fd1mfrk"},"title":{"Be2twd7":"fg38ndl","Bg96gwp":"f336tjw","Bhrd7zp":"fl43uef","sj55zd":"f19n0e5","fsow6f":"f17mccla","Bo78w4l":0,"Cgygva":0,"yil37a":"f8ntp42"},"description":{"B2u0y6b":"f6mdc4w","sj55zd":"f11d4kpn","fsow6f":"f17mccla","Bo78w4l":0,"Cgygva":0,"yil37a":"f8ntp42"},"actions":{"mc9l5x":"f22iagw","Eh141a":"fni485r","Brf1p80":"f4d9j23","i8kkvl":"fsnqrgy","Belr9w4":"f1wn3y0l","Cgygva":"f4zdp0h"}});
const HEADINGS = { 1: "h1", 2: "h2", 3: "h3", 4: "h4", 5: "h5", 6: "h6" };
function EmptyState({
  title,
  description,
  illustration,
  primaryAction,
  secondaryAction,
  headingLevel = 2,
  className
}) {
  const styles = useStyles();
  return /* @__PURE__ */ jsxs("div", { className: mergeClasses(styles.root, className), children: [
    illustration ? /* @__PURE__ */ jsx("span", { className: styles.illustration, "aria-hidden": "true", children: illustration }) : null,
    /* @__PURE__ */ jsx(Text, { as: HEADINGS[headingLevel], size: 500, weight: "semibold", className: styles.title, children: title }),
    description ? /* @__PURE__ */ jsx(Text, { as: "p", size: 300, className: styles.description, children: description }) : null,
    primaryAction || secondaryAction ? /* @__PURE__ */ jsxs("div", { className: styles.actions, children: [
      primaryAction ? /* @__PURE__ */ jsx(Button, { appearance: "primary", onClick: primaryAction.onClick, children: primaryAction.label }) : null,
      secondaryAction ? /* @__PURE__ */ jsx(Button, { appearance: "secondary", onClick: secondaryAction.onClick, children: secondaryAction.label }) : null
    ] }) : null
  ] });
}
export {
  EmptyState
};
//# sourceMappingURL=empty-state.js.map

import "/opt/batiflow/app/packages/ui/dist/components/empty-state/empty-state.griffel.css";